import React from "react";
import "./Refund.css";

export default function Refund() {
  return (
    <div className="policy-container">
      <h2 className="policy-title">Donations & Refund Policy</h2>

      <p className="policy-text">
        By contributing to OurCountryOurPeople Foundation, you acknowledge and agree that all donations
        made are voluntary and non-refundable. The organization retains the
        right to utilize the funds in a manner it deems most suitable for
        achieving its charitable objectives, within the framework of applicable
        laws and regulations.
      </p>

      <p className="policy-text">
        Donors understand that while every effort will be made to allocate
        donations as per their specified preferences, OurCountryOurPeople Foundation reserves the
        right to redirect funds to areas of greatest need. OurCountryOurPeople Foundation is committed
        to transparency and will provide periodic updates on the utilization of
        donations.
      </p>

      <p className="policy-text">
        Additionally, donors affirm that they are making contributions willingly
        and are responsible for complying with all tax regulations related to
        their donations. OurCountryOurPeople Foundation assures that it will handle personal
        information with utmost confidentiality and will not share donor
        details without explicit consent.
      </p>

      <p className="policy-text">
        This agreement is subject to change, and donors are encouraged to
        review the terms periodically.
      </p>
    </div>
  );
}
